export const PortalPageOptionInjectKey = 'PortalPageOption'

export type Normal = {
  /**
   * 头部左右中需要的组件名称数组
   */
  head: {
    /**
     * 左边需要的组件名称数组
     */
    left: Array<string>
    /**
     * 右边需要的组件名称数组
     */
    right: Array<string>
    /**
     * 中间需要的组件名称数组
     */
    center: Array<string>
  }
  /**
   * 底部需要的组件名称数组
   */
  footer: {
    /**
     * 组件名称数组
     */
    center?: Array<string>
  }
}

export type Layouts = {
  /**
   * 布局接口
   */
  normal: Normal
}

export type PortalPageOption = {
  /**
   * path: 自定义路径
   */
  path: string
  /**
   * name: 路径名称
   */
  name: string
  redirect?: undefined | string
  /**
   * layout: 布局接口
   */
  layout: Layouts
}
